import React from "react";
import clsx from "clsx";
import classes from "./LinkWithIcon.module.css";
const LinkWithIcon = ({
  options,
  icon,
  labelClass,
  label,
  onClick = () => {},
}) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        options.className,
        classes.wrapper
        // "w-full p-link flex align-items-center  p-2 pl-4 text-color hover:surface-200 border-noround"
      )}
    >
      {icon}
      <div className="flex flex-column align">
        <span className={clsx("font-bold", classes.label, labelClass)}>
          {label}
        </span>
      </div>
    </button>
  );
};

export default LinkWithIcon;
